import BaseOptionsBundle from "%/dynamic-components/render-engine/classes/base-options";
import StyledTextVariant from "%/dynamic-components/render-engine/options/text-options/styled-text-variant";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import TextBrandingStyleOption from "%/dynamic-components/render-engine/options/text-options/text-branding-style-option";
import TextOption from "%/dynamic-components/render-engine/options/text-options/text-option";

export default class BrandedTextStyleOptions extends BaseOptionsBundle {

  optionTitle = "Styled Text";
  static optionClassName = "i-dynamic-text";
  inspectorToolGroup = "styled-text";
  useInspectorLabel = false;

  static userInterfaceComponent = {
    component: inspectorTools.STYLED_TEXT_TOOL_SET,
  };

  constructor(values = {}, shouldHideFromInspector = {}) {
    super(values, [
      new TextBrandingStyleOption(undefined, shouldHideFromInspector["text-branding-style-option"] ?? false),
      new StyledTextVariant(undefined, shouldHideFromInspector["styled-text-variant"] ?? false),
      new TextOption(undefined, shouldHideFromInspector["text-option"] ?? false),
    ]);
  }
}
